"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var lightgallery_1 = require("./lightgallery");
function lightGallery(el, options) {
    return new lightgallery_1.LightGallery(el, options);
}
exports.default = lightGallery;
//# sourceMappingURL=index.js.map